// extracted by mini-css-extract-plugin
module.exports = {"navlink":"SidebarMessenger_navlink__1Y5bW","navlinkActive":"SidebarMessenger_navlinkActive__33xit","logout":"SidebarMessenger_logout__1YyYK"};